goog.provide("shadow.js.shim.module$$base_ui$react$select");
goog.provide("module$shadow_js_shim_module$$base_ui$react$select");
shadow.js.shim.module$$base_ui$react$select = shadow.js.nativeProvides["@base-ui/react/select"] = shadow$bridge("@base-ui/react/select");
module$shadow_js_shim_module$$base_ui$react$select.default = shadow.js.shim.module$$base_ui$react$select;
